import React from 'react';

const FormError = ({children, onClick}) => {
  const className = children.length > 1 ? "alert alert-danger errors-list" : "alert alert-danger"
  
  return (<div className={className} onClick={onClick}>
    {children}
  </div>)
};

export default FormError;


// WEBPACK FOOTER //
// ./src/components/form/FormError.js